import { render, staticRenderFns } from "./RecaptchaCompoent.vue?vue&type=template&id=83b9b812&scoped=true&"
import script from "./RecaptchaCompoent.vue?vue&type=script&lang=js&"
export * from "./RecaptchaCompoent.vue?vue&type=script&lang=js&"
import style0 from "./RecaptchaCompoent.vue?vue&type=style&index=0&id=83b9b812&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b9b812",
  null
  
)

export default component.exports